import { jsx as _jsx } from "react/jsx-runtime";
import { AllergenCodes } from "@wmart/shared-types";
const LABELS = {
    gluten: "Gluten",
    dairy: "Dairy",
    eggs: "Eggs",
    soy: "Soy",
    nuts: "Tree nuts",
    peanuts: "Peanuts",
    sesame: "Sesame",
    fish: "Fish",
    crustaceans: "Crustaceans",
    molluscs: "Molluscs",
    celery: "Celery",
    mustard: "Mustard",
    lupin: "Lupin",
    sulphites: "Sulphites",
};
export function AllergenChipPicker({ value, onChange, }) {
    function toggle(code) {
        if (value.includes(code))
            onChange(value.filter((c) => c !== code));
        else
            onChange([...value, code]);
    }
    return (_jsx("div", { className: "flex flex-wrap gap-2", children: AllergenCodes.options.map((code) => {
            const on = value.includes(code);
            return (_jsx("button", { type: "button", onClick: () => toggle(code), "aria-pressed": on, className: `rounded-pill px-3 py-1 text-caption font-medium ${on
                    ? "bg-danger-soft text-danger"
                    : "bg-paper border border-ink-200 text-ink-700 hover:bg-paper-warm"}`, children: LABELS[code] }, code));
        }) }));
}
